
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Attic Tent Required</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4" style="font-size: 24px;">
        This job requires an attic tent. Please ensure one is installed, and then take a picture of it.
        If you are unable to install one, or one is not required, go to the home page, scroll to the bottom, and enter the appropriate
        tag (either 'Attic Tent Not Required', or 'Unable to Install Attic Tent').
      </p>
      <button [mat-dialog-close]="2" mat-button color="primary" style="height: 75px;
    width: 200px;
    border: 0;
    font-size: 24px;
    font-weight: 700;
    background: #8bc34a;
    color: white;
    border-radius: 10px">Go Back</button>

<button [mat-dialog-close]="1" style="height:75px;
    width: 200px;
    border: 0;
    font-size: 24px;
    font-weight: 700;
    color: #8bc34a8a;
    background: #ffffff;
    border-radius: 10px">Close Anyway</button>


    </div>
  